import useSelectedPowerOfAttorney from "../useSelectedPowerOfAttorney";
import IsCorporateUser from "@portal/helpers/isCorporateUser";
import { IUseIsCorporateUser } from "./types";
import useAdvisor from "../useAdvisor";
import { useSession } from "@portal/auth/client/SessionProvider";

const useIsCorporateUser: IUseIsCorporateUser = () => {
  const { session } = useSession();
  const { data: selectedUser, isLoading: poaLoading } = useSelectedPowerOfAttorney();
  const { isAdvisor, impersonatedCustomerNumber, isLoading: advisorIsLoading } = useAdvisor();

  const userId = isAdvisor ? impersonatedCustomerNumber : selectedUser?.userId ? selectedUser?.userId : session?.user.id;

  const isCorporateUser = IsCorporateUser(userId);

  return {
    isCorporateUser,
    orgnumber: isCorporateUser ? userId : undefined,
    isLoading: poaLoading || advisorIsLoading,
  };
};

export default useIsCorporateUser;
